import type { AfterViewInit, OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'invd-bulk-upload-megas-container',
  templateUrl: './bulk-upload-megas-container.component.html',
  styleUrls: ['./bulk-upload-megas-container.component.scss'],
})
export class BulkUploadMegasContainerComponent implements OnInit, AfterViewInit {
  public steps: Array<object>;
  public currentStep = '/bulk-upload/enter-mega-details';
  public ignoreRoute: boolean;

  private router = inject(Router);

  ngOnInit() {
    this.buildProgressBar();
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        this.router.url === 'bulk-upload/enter-mega-details/confirmation'
      ) {
        this.ignoreRoute = true;
      }
    });
  }

  private buildProgressBar(): void {
    this.steps = [
      {
        title: 'Enter Pool Details',
        url: '/bulk-upload/enter-mega-details',
      },
      {
        title: 'Review Pool Details',
        url: '/bulk-upload/enter-mega-details/review-and-commit',
      },
      {
        title: 'Confirmation',
        url: '/bulk-upload/enter-mega-details/confirmation',
      },
    ];
  }
}
